import envHelper from "@digits-shared/helpers/envHelper"
import { css } from "styled-components"
import { ComponentSize } from "src/frontend/components/Shared/Layout/ComponentSize"

/** Style helper function for turning ComponentSize into icon styles */
export function categoryIconSizeStyles({ componentSize }: { componentSize: ComponentSize }) {
  switch (componentSize) {
    case ComponentSize.Small:
    case ComponentSize.PageSmall:
      return css`
        height: 23px;
        width: 23px;
      `

    case ComponentSize.Medium:
    case ComponentSize.PageMedium:
      return css`
        height: 26px;
        width: 26px;
      `

    case ComponentSize.Large:
    case ComponentSize.ExtraLarge:
      return css`
        margin-top: -2px;
        height: 28px;
        width: 28px;
      `
    default:
      if (!envHelper.isProduction()) {
        throw new Error(`Invalid component size ${componentSize.name} in categoryIconSizeStyles`)
      }
      return undefined
  }
}
